var map = {
	"./tab/Ellipse5.svg": "./src/components/LandingPages/images/contact/tab/Ellipse5.svg",
	"./web/Ellipse5.svg": "./src/components/LandingPages/images/contact/web/Ellipse5.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/LandingPages/images/contact sync recursive ^.*Ellipse5\\.svg$";